import React, { Component } from "reactn";
import { BlueButton, UIPane, UIPaneContents } from "js/react/components/UiComponents";
import { app } from "js/namespaces";
import { FeatureType } from "common/features";
import { FlexSpacer, Gap10, Gap20, Gap30 } from "js/react/components/Gap";
import { getStaticUrl } from "js/config";
import { Icon, IconButton, TextField } from "@material-ui/core";
import { FlexBox } from "js/react/components/LayoutGrid";
import { Notice } from "js/react/components/Notice";
import { openPricingPage } from "js/core/utilities/externalLinks";
import styled from "styled-components";
import { themeColors } from "js/react/sharedStyles";
import { delay } from "js/core/utilities/promiseHelper";
import { BetaBadge } from "js/react/components/BetaBadge";
import { ToggleButton } from "@material-ui/lab";

const Frame = styled.div`
  margin: auto;
  max-width: 1100px;
  position: relative;
`;

const SearchPane = styled.div`
  padding: 20px 40px;
  margin-top: 16px;
  background: white;
  border-radius: 4px;
  width: 100%;
  display: flex;
  flex-direction: column;


  h1 {
    text-transform: none !important;
    font-size: 22px !important;
    margin: 0 !important;
  }

  p {
    font-size: 15px;
    opacity: 0.8;
  }

  .MuiInputBase-input::-webkit-input-placeholder {
    opacity: 0.66;
    color: ${themeColors.ui_blue};
    font-weight: 500;
  }

  .MuiToggleButton-root {
    border-radius: 50%;
  }
`;

const OpenAiLogoContainer = styled.div`
  position: absolute;
  bottom: 10px;
  left: 20px;
  display: flex;
  align-items: center;
  z-index: 99999;

  > img {
    margin-right: 10px;
  }

  > a {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: #666666;
    text-decoration: none;

    &:hover {
      color: #11A9E2;
    }
  }
`;

const Header = styled.div`
  font-size: 30px;
  font-weight: bold;
  margin-top: 10px;
  width: 100%;
  letter-spacing: 0em;
  display: flex;
  align-items: center;
  font-family: "Source Sans Pro Heavy";
`;

const DesignerBot = styled.img`
  position: absolute;
  top: -25px;
  left: -25px;
  border-radius: 50%;
  border: solid 3px ${themeColors.ui_blue};
  height: 50px;
`;

const Label = styled.div`
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .MuiIcon-root {
    margin-right: 6px;
    font-size: 16px;
    opacity: 0.75;
    color: ${themeColors.ui_blue}
  }
`;

const ButtonPanel = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  //font-weight: 600;
  color: orangered;

  button {
    flex-shrink: 0;
  }
`;
const ExampleFrame = styled.div`
  //margin: 0px 50px; 
`;

const Examples = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 7px;
`;

const ExampleButton = styled.div`
  cursor: pointer;
  background: white;
  font-size: 14px;
  padding: 14px 14px;
  border-radius: 3px;
  display: flex;
  align-items: center;

  :hover {
    background: ${themeColors.selection};
  }
`;

const Warning = styled.div`
  padding: 10px 20px;
  color: rgba(0, 0, 0, 0.85);
  background: ${themeColors.lightBlue};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
`;

export const AIGenerationProgress = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .spinner {
    position: relative !important;
    width: 75px;
    height: 75px;
  }

  label {
    font-family: "Source Sans Pro Heavy";
    font-size: 20px;
    font-weight: 900;
    max-width: 60%;
    text-align: center;
  }
`;

export class AIGenerateUI extends Component {
    constructor(props) {
        super(props);

        this.state = {
            prompt: "",
            generating: false,
            isUsingSpeech: false
        };
    }

    componentWillUnmount() {
        if (this.speechToText) {
            this.speechToText.stop();
        }
    }

    handleSpeech = () => {
        if (this.state.isUsingSpeech) {
            this.setState({ isUsingSpeech: false });
            if (this.speechToText) {
                this.speechToText.stop();
            }
        } else {
            window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
            this.speechToText = new window.SpeechRecognition();
            this.speechToText.interimResults = true;
            this.speechToText.continuous = true;

            this.speechToText.addEventListener("result", e => {
                const transcript = Array.from(e.results)
                    .map(result => result[0])
                    .map(result => result.transcript)
                    .join("");

                this.setState({ prompt: transcript });
            });

            this.speechToText.start();
            this.setState({ isUsingSpeech: true });
        }
    }

    handleChangePrompt = event => {
        this.setState({
            prompt: event.target.value
        });
    }

    handleInput = event => {
        if (event.which == 13) {
            this.handleStartGeneration();
        }
    }

    handleStartGeneration = async () => {
        if (this.speechToText) {
            this.speechToText.stop();
        }
        this.props.onStartGeneration(this.state.prompt, this);
    }

    handleExample = async example => {
        this.setState({ prompt: "" }, async () => {
            for (let ch of example) {
                this.setState({ prompt: this.state.prompt + ch });
                await delay(10);
            }
        });
    }

    render() {
        let { header, description, placeholder, buttonPrompt, examples, cta } = this.props;
        let { prompt, isUsingSpeech } = this.state;

        let canAccess = app.user?.features.isFeatureEnabled(FeatureType.DESIGNER_BOT, app.appState.workspaceId) || true;

        return (
            <UIPane>
                <UIPaneContents style={{ padding: "30px 50px" }}>
                    {canAccess &&
                        <Frame>
                            <SearchPane>
                                <DesignerBot src={getStaticUrl("/images/bai-bot/bai-bot-shake.gif")} />
                                <Header>
                                    {header}
                                    <Gap10 />
                                    <BetaBadge small />
                                </Header>
                                <div>
                                    {description}
                                </div>
                                <Gap30 />
                                <FlexBox middle left>
                                    <ToggleButton selected={isUsingSpeech || false}
                                        onClick={this.handleSpeech}><Icon>mic</Icon></ToggleButton>
                                    <Gap10 />
                                    <TextField
                                        id="prompt"
                                        value={prompt}
                                        onChange={this.handleChangePrompt}
                                        onKeyUp={this.handleInput}
                                        fullWidth
                                        inputProps={{
                                            style: { fontSize: 20 },
                                        }}
                                        style={{ background: "white" }}
                                        inputRef={input => input && input.focus()}
                                        placeholder={placeholder}
                                    />
                                </FlexBox>
                                <Gap30 />
                                <ButtonPanel>
                                    <FlexSpacer />
                                    <BlueButton
                                        onClick={this.handleStartGeneration}
                                        style={{ fontSize: 16, padding: "10px 40px" }}
                                    >{buttonPrompt}</BlueButton>
                                </ButtonPanel>
                            </SearchPane>
                            <Gap20 />
                            <Warning>
                                NOTE: DesignerBot's AI is still learning and evolving so it may
                                still
                                generate odd, incorrect or
                                incomplete results
                                occasionally. Please check it's work.
                            </Warning>
                            <Gap20 />
                            <Gap20 />
                            <ExampleFrame>
                                <Label><Icon>lightbulb</Icon>Start from an Example</Label>
                                <Gap20 />
                                <Examples>
                                    {examples.map(example => (<ExampleButton key={example}
                                        onClick={() => this.handleExample(example)}>{example}</ExampleButton>))}
                                </Examples>
                            </ExampleFrame>
                            <Gap30 />
                        </Frame>
                    }
                    {!canAccess &&
                        <Notice
                            title="Let DesignerBot generate a custom slides."
                            message={
                                <>
                                    <div>Upgrade to Beautiful.ai Pro to use AI to generate content for you.</div>
                                    <BlueButton
                                        style={{ marginBottom: 0 }}
                                        onClick={() => openPricingPage(app.user.analyticsPersonalPlan, { cta })}
                                    >Get Started</BlueButton>
                                </>
                            }
                        />
                    }
                    <OpenAiLogoContainer>
                        <img src={getStaticUrl("/images/ai-search/dall-e-logo.png")} />
                        <a href="https://openai.com/" target="_blank">Powered by OpenAI</a>
                    </OpenAiLogoContainer>
                </UIPaneContents>
            </UIPane>
        );
    }
}

